export const BET = 'betAmount';
export const AUTOPLAY = 'autoplay';

